import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_base/_auth/campaigns/$id/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()

  return <Navigate to="/campaigns/$id/insights" params={{ id }} replace />
}
